import { render, staticRenderFns } from "./studentTitleCardV2.vue?vue&type=template&id=10f0b858&scoped=true&"
import script from "./studentTitleCardV2.vue?vue&type=script&lang=js&"
export * from "./studentTitleCardV2.vue?vue&type=script&lang=js&"
import style0 from "./studentTitleCardV2.vue?vue&type=style&index=0&id=10f0b858&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0b858",
  null
  
)

export default component.exports